export const Show = () => import("./Show.vue");
export const List = () => import("./List.vue");
export const CompanyRank = () => import("./CompanyRank.vue");
export const DateCompany = () => import("./DateCompany.vue");
export const CompanyDemand = () => import("./CompanyDemand.vue");
export const BattalionDeman = () => import("./BattalionDeman.vue");
